import Vue from 'vue';

/*

*  使用方法

*  将以下代码复制到一个js文件中，然后在入口文件main.js中import引入即可；

*  给elementUI的dialog上加上 v-dialogDrag 指令就可以实现弹窗的全屏和拉伸了。

*  给dialog设置 :close-on-click-modal="false" , 禁止点击遮罩层关闭弹出层

*  如果是form表单，不要将提交等按钮放置el-form-item，以免在上下拉伸时被隐藏

*/

// v-dialogDrag: 弹窗拖拽+水平方向伸缩

Vue.directive('dialogDrag', {

  bind(el, binding, vnode, oldVnode) {

    //弹框可拉伸最小宽高

    let minWidth = 500;

    let minHeight = 300;

    //初始非全屏

    let isFullScreen = false;

    //当前宽高

    let nowWidth = 0;

    let nowHight = 0;

    //当前左边距离
    let nowLeft = 0;
    //当前顶部距离
    let nowTop = 0;

    //获取弹框头部（这部分可双击全屏）

    const dialogHeaderEl = el.querySelector('.el-dialog__header');

    //弹窗

    const dragDom = el.querySelector('.el-dialog');
    // const dragDomBody = el.querySelector('.el-dialog__body');

    //给弹窗加上overflow auto；不然缩小时框内的标签可能超出dialog；

    dragDom.style.overflow = "auto";

    //清除选择头部文字效果

    //dialogHeaderEl.onselectstart = new Function("return false");

    //头部加上可拖动cursor

    dialogHeaderEl.style.cursor = 'move';

    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);

    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const sty = (function() {
      if (window.document.currentStyle) {
        return (dom, attr) => dom.currentStyle[attr];
      } else{
        return (dom, attr) => getComputedStyle(dom, false)[attr];
      }
    })()
    const dialogSty = window.getComputedStyle(dialogHeaderEl, null);
    let moveDown = (e) => {
       e.preventDefault();
       e.stopPropagation();
       if(dialogSty.cursor === "not-allowed"){
         return false;
       }
      $(".courseSubDialog").css("pointer-events","auto");
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - dialogHeaderEl.offsetLeft;

      const disY = e.clientY - dialogHeaderEl.offsetTop;

      const screenWidth = document.body.clientWidth; // body当前宽度
      const screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)

      const dragDomWidth = dragDom.offsetWidth; // 对话框宽度
      const dragDomheight = dragDom.offsetHeight; // 对话框高度

      const minDragDomLeft = dragDom.offsetLeft;
      const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth;

      const minDragDomTop = dragDom.offsetTop;
      const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomheight;

      // 获取到的值带px 正则匹配替换
      let styL = sty(dragDom, 'left');
      let styT = sty(dragDom, 'top');

      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px

      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      if(styL.includes('%')) {
        styL = +document.body.clientWidth * (+styL.replace(/\%/g, '') / 100);
        styT = +document.body.clientHeight * (+styT.replace(/\%/g, '') / 100);
      }else {
        styL = +styL.replace(/\px/g, '');
        styT = +styT.replace(/\px/g, '');
      };

      document.onmousemove = function (e) {

        // 通过事件委托，计算移动的距离
        let left = e.clientX - disX;
        let top = e.clientY - disY;

        // 边界处理
        if (-(left) > minDragDomLeft) {
          left = -(minDragDomLeft);
        } else if (left > maxDragDomLeft) {
          left = maxDragDomLeft;
        }

        if (-(top) > minDragDomTop) {
          top = -(minDragDomTop);
        } else if (top > maxDragDomTop) {
          top = maxDragDomTop;
        }

        // 移动当前元素
        dragDom.style.cssText += `;left:${left + styL}px;top:${top + styT}px;`;

        //将此时的位置传出去

        // binding.value({x:e.pageX,y:e.pageY})

      };
      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
        $(".courseSubDialog").css("pointer-events","none");
      };

    }

    dialogHeaderEl.onmousedown = moveDown;

    //双击头部全屏效果
    // dialogHeaderEl.ondblclick = (e) => {
    //
    //   if (!isFullScreen) {
    //
    //     nowHight = dragDom.clientHeight;
    //     nowWidth = dragDom.clientWidth;
    //     nowLeft = dragDom.style.left;
    //     nowTop = dragDom.style.top;
    //
    //     dragDom.style.left = 0;
    //     dragDom.style.top = 0;
    //     dragDom.style.height = "100VH";
    //     dragDom.style.width = "100VW";
    //     dragDom.style.marginTop = 0;
    //     dialogHeaderEl.style.cursor = 'initial';
    //     dialogHeaderEl.onmousedown = null;
    //     isFullScreen = true;
    //
    //   } else {
    //
    //     dragDom.style.height = nowHight + 'px';
    //     dragDom.style.width = nowWidth + 'px';
    //     dragDom.style.left = nowLeft;
    //     dragDom.style.top = nowTop;
    //     dialogHeaderEl.style.cursor = 'move';
    //     dialogHeaderEl.onmousedown = moveDown;
    //     isFullScreen = false;
    //
    //   }
    //
    // }

    dragDom.onmousemove = function (e) {


      /* 有空再写 */

      // if ((e.path[1].clientHeight == window.innerHeight) || ((e.path[1].clientWidth+10) > window.innerWidth)) {
      //
      //   dragDom.style.cursor = 'default';
      //
      // } else if (e.clientX > dragDom.offsetLeft + dragDom.clientWidth - 10 || dragDom.offsetLeft + 10 > e.clientX) {
      //
      //   dragDom.style.cursor = 'w-resize';
      //
      // } else if (el.scrollTop + e.clientY > dragDom.offsetTop + dragDom.clientHeight - 10 || dragDom.offsetTop + 10 > e.clientY) {
      //
      //   dragDom.style.cursor = 's-resize';
      //
      // } else {
      //   dragDom.style.cursor = 'default';
      //   dragDom.onmousedown = null;
      // }

      dragDom.onmousedown = (e) => {

        $(".courseSubDialog").css("pointer-events","auto");

        const clientX = e.clientX;

        const clientY = e.clientY;

        let elW = dragDom.clientWidth;

        let elH = dragDom.clientHeight;

        let EloffsetLeft = dragDom.offsetLeft;

        let EloffsetTop = dragDom.offsetTop;

        dragDom.style.userSelect = 'none';

        let ELscrollTop = el.scrollTop;
        //判断点击的位置是不是为头部

        if (clientX > EloffsetLeft && clientX < EloffsetLeft + elW && clientY > EloffsetTop && clientY < EloffsetTop + 100) {
          //如果是头部在此就不做任何动作，以上有绑定dialogHeaderEl.onmousedown = moveDown;
          document.onmousemove = function (e) {
            //e.preventDefault(); // 移动时禁用默认事件
            //顶部鼠标拖拽位置
            if(clientY > EloffsetTop && clientY < EloffsetTop + 10){

              //往上拖拽

              if(clientY > e.clientY){
                dragDom.style.top = e.clientY + 'px';
                dragDom.style.marginTop = 0 + 'px';
                dragDom.style.height = elH + (clientY - e.clientY) + 'px';

              }
              //往下拖拽

              if(clientY < e.clientY){
                if(dragDom.style.height < minHeight){

                }else{
                  dragDom.style.top = e.clientY + 'px';
                  dragDom.style.marginTop = 0 + 'px';
                  dragDom.style.height = elH - (e.clientY - clientY ) + 'px';
                }
              }


            }

          };
          document.onmouseup = function (e) {
            document.onmousemove = null;
            document.onmouseup = null;

          };
        }else{

          document.onmousemove = function (e) {
            //e.preventDefault(); // 移动时禁用默认事件

            //左侧鼠标拖拽位置

            if (clientX > EloffsetLeft && clientX < EloffsetLeft + 10) {

              //往左拖拽

              if (clientX > e.clientX) {
                dragDom.style.left = e.clientX + 'px';
                dragDom.style.width = elW + (clientX - e.clientX) + 'px';

              }

              //往右拖拽

              if (clientX < e.clientX) {

                if(dragDom.clientWidth < minWidth){

                }else{
                  dragDom.style.left = e.clientX + 'px';
                  dragDom.style.width = elW - (e.clientX - clientX) + 'px';

                }

              }

            }

            //右侧鼠标拖拽位置

            if (clientX > EloffsetLeft + elW - 10 && clientX < EloffsetLeft + elW) {

              //往左拖拽

              if (clientX > e.clientX) {

                if (dragDom.clientWidth < minWidth) {

                } else {

                  dragDom.style.width = elW - (clientX - e.clientX) + 'px';

                }

              }

              //往右拖拽

              if (clientX < e.clientX) {

                dragDom.style.width = elW + (e.clientX - clientX) + 'px';

              }

            }

            //底部鼠标拖拽位置

            if (ELscrollTop + clientY > EloffsetTop + elH - 20 && ELscrollTop + clientY < EloffsetTop + elH) {

              //往上拖拽

              if (clientY > e.clientY) {

                if (dragDom.clientHeight < minHeight) {

                } else {

                  dragDom.style.height = elH - (clientY - e.clientY) + 'px';

                }

              }

              //往下拖拽

              if (clientY < e.clientY) {

                dragDom.style.height = elH + (e.clientY - clientY) + 'px';

              }

            }

          };

        }

        //拉伸结束

        document.onmouseup = function (e) {
          $(".courseSubDialog").css("pointer-events","none");
          document.onmousemove = null;
          document.onmouseup = null;
        };

      }

    }

  }

})



// WEBPACK FOOTER //
// ./src/libs/drag/drag.js